'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.CMSFieldTypes = void 0;
(function (CMSFieldTypes) {
    CMSFieldTypes["Image"] = "image";
    CMSFieldTypes["Number"] = "number";
    CMSFieldTypes["RadioSelect"] = "radio_select";
    CMSFieldTypes["Text"] = "text";
    CMSFieldTypes["TextArea"] = "text_area";
    CMSFieldTypes["Toggle"] = "toggle";
    CMSFieldTypes["ToggleWithNestedOptions"] = "toggle_with_nested_options";
    CMSFieldTypes["Wysiwyg"] = "wysiwyg";
})(exports.CMSFieldTypes || (exports.CMSFieldTypes = {}));
exports.MetadataTypes = void 0;
(function (MetadataTypes) {
    MetadataTypes["Object"] = "cms:object";
    MetadataTypes["Field"] = "cms:field";
})(exports.MetadataTypes || (exports.MetadataTypes = {}));
exports.MessageSources = void 0;
(function (MessageSources) {
    MessageSources["PREVIEW_APPLICATION"] = "preview_application";
    MessageSources["CMS_APPLICATION"] = "cms_application";
})(exports.MessageSources || (exports.MessageSources = {}));
exports.PreviewActions = void 0;
(function (PreviewActions) {
    PreviewActions["PREVIEW_LOADED"] = "preview_loaded";
    PreviewActions["MODULE_SECTION_EDIT"] = "module_section_edit";
    PreviewActions["MODULE_SECTION_REMOVE"] = "module_section_remove";
    PreviewActions["WEBSITE_PAGE_DATA"] = "website_page_data";
})(exports.PreviewActions || (exports.PreviewActions = {}));
exports.DataRequirementTypes = void 0;
(function (DataRequirementTypes) {
    DataRequirementTypes["WebsiteLocation"] = "website_location";
    DataRequirementTypes["Menu"] = "menu";
})(exports.DataRequirementTypes || (exports.DataRequirementTypes = {}));
exports.CustomStyleTargets = void 0;
(function (CustomStyleTargets) {
    CustomStyleTargets["NONE"] = "";
    CustomStyleTargets["CTA"] = "bentobox--cta";
    CustomStyleTargets["NAV_LINK"] = "bentobox--nav-link";
    CustomStyleTargets["POWERED_BY"] = "bentobox--site-powered-by";
    CustomStyleTargets["FOOTER_SOCIAL_ICONS"] = "bentobox--footer--social-icon";
    CustomStyleTargets["STORE_LOCATOR_LOCATIONS"] = "sections.maps.StoreLocator--locations-container";
    CustomStyleTargets["PANEL_IMAGE"] = "sections.base.Panel--image";
    CustomStyleTargets["STORE_LOCATOR_CTA"] = "sections.maps.StoreLocator--cta";
    CustomStyleTargets["STORE_LOCATOR_MODAL_CTA"] = "sections.maps.StoreLocator--modal--cta";
})(exports.CustomStyleTargets || (exports.CustomStyleTargets = {}));
//# sourceMappingURL=enums.js.map
